var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 156.97 28.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f0c62f;}.cls-2{fill:#da004f;}.cls-3{fill:#da00c6;}.cls-4{fill:#77c12d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 28.73,
    height: 28.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 44.12,
    width: 28.73,
    height: 28.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 89.26,
    width: 28.73,
    height: 28.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 128.25,
    width: 28.73,
    height: 28.73
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColors);
export default __webpack_public_path__ + "static/media/colors.6e7e3304722d8ae680d676a167cef9c4.svg";
export { ForwardRef as ReactComponent };